export default __webpack_public_path__ + "static/logo-e5573dd7671739c22ef08c57acb7d39c.svg";